import { isDarkMode } from "../../Common/DarkMode/DarkModeHooks";

export type RGBType = {
    r: number;
    g: number;
    b: number;
    hash?: boolean;
};

export const CSS_COLOURS: Record<string, string> = {
    "aliceblue"           : "#f0f8ff",
    "antiquewhite"        : "#faebd7",
    "aqua"                : "#00ffff",
    "aquamarine"          : "#7fffd4",
    "azure"               : "#f0ffff",
    "beige"               : "#f5f5dc",
    "bisque"              : "#ffe4c4",
    "black"               : "#000000",
    "blanchedalmond"      : "#ffebcd",
    "blue"                : "#0000ff",
    "blueviolet"          : "#8a2be2",
    "brown"               : "#a52a2a",
    "burlywood"           : "#deb887",
    "cadetblue"           : "#5f9ea0",
    "chartreuse"          : "#7fff00",
    "chocolate"           : "#d2691e",
    "coral"               : "#ff7f50",
    "cornflowerblue"      : "#6495ed",
    "cornsilk"            : "#fff8dc",
    "crimson"             : "#dc143c",
    "cyan"                : "#00ffff",
    "darkblue"            : "#00008b",
    "darkcyan"            : "#008b8b",
    "darkgoldenrod"       : "#b8860b",
    "darkgray"            : "#a9a9a9",
    "darkgreen"           : "#006400",
    "darkkhaki"           : "#bdb76b",
    "darkmagenta"         : "#8b008b",
    "darkolivegreen"      : "#556b2f",
    "darkorange"          : "#ff8c00",
    "darkorchid"          : "#9932cc",
    "darkred"             : "#8b0000",
    "darksalmon"          : "#e9967a",
    "darkseagreen"        : "#8fbc8f",
    "darkslateblue"       : "#483d8b",
    "darkslategray"       : "#2f4f4f",
    "darkturquoise"       : "#00ced1",
    "darkviolet"          : "#9400d3",
    "deeppink"            : "#ff1493",
    "deepskyblue"         : "#00bfff",
    "dimgray"             : "#696969",
    "dodgerblue"          : "#1e90ff",
    "firebrick"           : "#b22222",
    "floralwhite"         : "#fffaf0",
    "forestgreen"         : "#228b22",
    "fuchsia"             : "#ff00ff",
    "gainsboro"           : "#dcdcdc",
    "ghostwhite"          : "#f8f8ff",
    "gold"                : "#ffd700",
    "goldenrod"           : "#daa520",
    "gray"                : "#808080",
    "green"               : "#008000",
    "greenyellow"         : "#adff2f",
    "honeydew"            : "#f0fff0",
    "hotpink"             : "#ff69b4",
    "indianred "          : "#cd5c5c",
    "indigo"              : "#4b0082",
    "ivory"               : "#fffff0",
    "khaki"               : "#f0e68c",
    "lavender"            : "#e6e6fa",
    "lavenderblush"       : "#fff0f5",
    "lawngreen"           : "#7cfc00",
    "lemonchiffon"        : "#fffacd",
    "lightblue"           : "#add8e6",
    "lightcoral"          : "#f08080",
    "lightcyan"           : "#e0ffff",
    "lightgoldenrodyellow": "#fafad2",
    "lightgrey"           : "#d3d3d3",
    "lightgreen"          : "#90ee90",
    "lightpink"           : "#ffb6c1",
    "lightsalmon"         : "#ffa07a",
    "lightseagreen"       : "#20b2aa",
    "lightskyblue"        : "#87cefa",
    "lightslategray"      : "#778899",
    "lightsteelblue"      : "#b0c4de",
    "lightyellow"         : "#ffffe0",
    "lime"                : "#00ff00",
    "limegreen"           : "#32cd32",
    "linen"               : "#faf0e6",
    "magenta"             : "#ff00ff",
    "maroon"              : "#800000",
    "mediumaquamarine"    : "#66cdaa",
    "mediumblue"          : "#0000cd",
    "mediumorchid"        : "#ba55d3",
    "mediumpurple"        : "#9370d8",
    "mediumseagreen"      : "#3cb371",
    "mediumslateblue"     : "#7b68ee",
    "mediumspringgreen"   : "#00fa9a",
    "mediumturquoise"     : "#48d1cc",
    "mediumvioletred"     : "#c71585",
    "midnightblue"        : "#191970",
    "mintcream"           : "#f5fffa",
    "mistyrose"           : "#ffe4e1",
    "moccasin"            : "#ffe4b5",
    "navajowhite"         : "#ffdead",
    "navy"                : "#000080",
    "oldlace"             : "#fdf5e6",
    "olive"               : "#808000",
    "olivedrab"           : "#6b8e23",
    "orange"              : "#ffa500",
    "orangered"           : "#ff4500",
    "orchid"              : "#da70d6",
    "palegoldenrod"       : "#eee8aa",
    "palegreen"           : "#98fb98",
    "paleturquoise"       : "#afeeee",
    "palevioletred"       : "#d87093",
    "papayawhip"          : "#ffefd5",
    "peachpuff"           : "#ffdab9",
    "peru"                : "#cd853f",
    "pink"                : "#ffc0cb",
    "plum"                : "#dda0dd",
    "powderblue"          : "#b0e0e6",
    "purple"              : "#800080",
    "rebeccapurple"       : "#663399",
    "red"                 : "#ff0000",
    "rosybrown"           : "#bc8f8f",
    "royalblue"           : "#4169e1",
    "saddlebrown"         : "#8b4513",
    "salmon"              : "#fa8072",
    "sandybrown"          : "#f4a460",
    "seagreen"            : "#2e8b57",
    "seashell"            : "#fff5ee",
    "sienna"              : "#a0522d",
    "silver"              : "#c0c0c0",
    "skyblue"             : "#87ceeb",
    "slateblue"           : "#6a5acd",
    "slategray"           : "#708090",
    "snow"                : "#fffafa",
    "springgreen"         : "#00ff7f",
    "steelblue"           : "#4682b4",
    "tan"                 : "#d2b48c",
    "teal"                : "#008080",
    "thistle"             : "#d8bfd8",
    "tomato"              : "#ff6347",
    "turquoise"           : "#40e0d0",
    "violet"              : "#ee82ee",
    "wheat"               : "#f5deb3",
    "white"               : "#ffffff",
    "whitesmoke"          : "#f5f5f5",
    "yellow"              : "#ffff00",
    "yellowgreen"         : "#9acd32",
};

/**
 * Generate a colour from a string
 * @param string
 * @param darkMode
 */
export function generateColourFromString(
    string: string,
    darkMode?: boolean
): string {
    let hash = 0;

    // Add padding
    while(string.length < 6) {
        string += "0";
    }

    for(let i = 0, l = string.length; i < l; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let colour = "#";

    if(typeof darkMode !== "boolean") {
        darkMode = isDarkMode();
    }

    for(let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF;

        if(darkMode) {
            // Make the colors tend more towards dark and desaturated (blend the generated colour with dark grey)
            value = Math.round((0x12 + value) / 2);
        } else {
            // Make the colors tend more towards pastels (blend the generated colour with light grey)
            value = Math.round((0xD9 + value) / 2);
        }

        colour += ("00" + value.toString(16)).slice(-2);
    }

    return colour;
}

/**
 * Converts
 * @param colour
 * @returns {{r: number, b: number, g: number, hash: boolean}}
 */
function hexToRGB(colour: string): RGBType {
    // Check if we have a colour
    let hash = false;

    if(colour.charAt(0) === "#") {
        hash = true;
        colour = colour.slice(1);
    }

    // Convert the colour to a number
    const converted = parseInt(colour, 16);

    // Get the RGB values
    const r = (converted >> 16);
    const g = (converted & 0x0000FF);
    const b = ((converted >> 8) & 0x00FF);

    return {
        r,
        g,
        b,
        hash,
    };
}

/**
 * Clamp RGB values between 0 and 255
 * @param rgb
 */
function clampRGB(rgb: RGBType): RGBType {
    let { r, g, b } = rgb;

    if(r > 255) {
        r = 255;
    } else if(r < 0) {
        r = 0;
    }

    if(g > 255) {
        g = 255;
    } else if(g < 0) {
        g = 0;
    }

    if(b > 255) {
        b = 255;
    } else if(b < 0) {
        b = 0;
    }

    return {
        hash: rgb.hash,
        r,
        g,
        b,
    };
}

/**
 * Convert RGB input to Hex string
 * @param rgb
 * @returns {string}
 * @constructor
 */
function RGBToHex(rgb: RGBType): string {
    const { r, g, b, hash } = clampRGB(rgb);

    // Convert back into a hex colour
    const newColour = (g | (b << 8) | (r << 16)).toString(16);

    // Return the new colour
    return (hash ? "#" : "") + newColour;
}

/**
 * Make a hex colour darker
 * @param {string} colour
 * @param {number} amount
 * @returns {string}
 */
export function darkenColour(colour: string, amount: number): string {
    const rgb = hexToRGB(colour);

    const adjust = (Math.min(rgb.r, rgb.b, rgb.g) * (amount / 100));

    rgb.r -= adjust;
    rgb.g -= adjust;
    rgb.b -= adjust;

    return RGBToHex(rgb);
}

/**
 * Make a hex colour lighter
 * @alias shadeHexColour
 * @param {string} colour
 * @param {number} amount
 * @returns {string}
 */
export function lightenColour(colour: string, amount: number): string {
    const rgb = hexToRGB(colour);

    // Get the range that the colour can be lightened by
    const range = 255 - Math.max(rgb.r, rgb.b, rgb.g);
    const adjust = (range * (amount / 100));

    rgb.r += adjust;
    rgb.g += adjust;
    rgb.b += adjust;

    return RGBToHex(rgb);
}
